import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { FaThList, FaSchool, FaChalkboardTeacher } from "react-icons/fa";

import Timetable from "./Timetable";
import SchoolTimetable from "./SchoolTimetable";
import TeacherLoad from "./TeacherLoad";
import "./timetable.css";

export default function TimetableDashboard() {
  const [key, setKey] = useState("class");

  return (
    <div className="row">
      <div className="col-xl-12">

        <div className="page-title mb-4">
          <h4>Academic Timetable</h4>
        </div>

        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-4 nav-pills custom-tabs"
        >
          <Tab
            eventKey="class"
            title={
              <>
                <FaThList className="me-2" />
                Class View
              </>
            }
          >
            <Timetable />
          </Tab>

          <Tab
            eventKey="school"
            title={
              <>
                <FaSchool className="me-2" />
                School View
              </>
            }
          >
            <SchoolTimetable />
          </Tab>

          <Tab
            eventKey="teacher"
            title={
              <>
                <FaChalkboardTeacher className="me-2" />
                Teacher Load
              </>
            }
          >
            <TeacherLoad />
          </Tab>

        </Tabs>

      </div>
    </div>
  );
}